// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"Image_formWrapper__1iY22","formLabel":"Image_formLabel__MRWrO","imageWrapper":"Image_imageWrapper__3cWxy","image":"Image_image__3Peai"};